var _rect, _path, _path2, _g, _path3, _path4, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 20,
    fill: "#06BA63"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.84992,
    clipPath: "url(#clip0_2046_58056)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M15.7522 22.5156H39.5494C40.6503 22.5156 41.5438 23.4086 41.5438 24.5089C41.5438 25.6092 40.6503 26.5022 39.5494 26.5022H15.7522C14.6513 26.5022 13.7578 25.6092 13.7578 24.5089C13.7578 23.4086 14.6513 22.5156 15.7522 22.5156Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2046_58056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 37,
    y: 14,
    width: 18,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4219 35.4653V14H54.583V35.4653H37.4219Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2046_58056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7688 14.1797C39.0202 14.1797 39.268 14.2497 39.4871 14.3861L53.7394 23.3623C54.1308 23.61 54.3698 24.039 54.3698 24.502C54.3698 24.9651 54.1308 25.3941 53.7394 25.6418L39.4871 34.618C39.0723 34.8782 38.5479 34.8944 38.1187 34.6556C37.6876 34.4187 37.4219 33.9682 37.4219 33.4783V15.5258C37.4219 15.0358 37.6876 14.5853 38.1187 14.3484C38.3216 14.2353 38.5461 14.1797 38.7688 14.1797Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.3151 46.0569H28.5179C27.4169 46.0569 26.5234 45.1639 26.5234 44.0636C26.5234 42.9632 27.4169 42.0703 28.5179 42.0703H52.3151C53.4159 42.0703 54.3095 42.9632 54.3095 44.0636C54.3095 45.1639 53.4159 46.0569 52.3151 46.0569Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2046_58056",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 33,
    width: 18,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5127 33.1094V54.5746H13.3516V33.1094H30.5127Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2046_58056)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1634 54.3948C28.912 54.3948 28.6642 54.3248 28.4451 54.1884L14.1929 45.2122C13.8014 44.9645 13.5625 44.5355 13.5625 44.0724C13.5625 43.6094 13.8014 43.1804 14.1929 42.9327L28.4451 33.9566C28.86 33.6962 29.3844 33.6801 29.8136 33.9188C30.2446 34.1557 30.5104 34.6062 30.5104 35.0963V53.0487C30.5104 53.5387 30.2446 53.9892 29.8136 54.2261C29.6106 54.3391 29.3861 54.3948 29.1634 54.3948Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2046_58056"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 41,
    fill: "white",
    transform: "translate(13 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiv);
export default __webpack_public_path__ + "static/media/div.80b84a240e611ebc5b5b1ff8c590002f.svg";
export { ForwardRef as ReactComponent };